
import React from 'react';
import { Shield, Server, Users, LockKeyhole } from 'lucide-react';

const SecurityPrinciples: React.FC = () => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm flex items-start">
          <Shield className="text-itmgmt-medium-blue mr-3 mt-1 flex-shrink-0" size={20} />
          <div>
            <h3 className="font-semibold text-itmgmt-dark-blue mb-1">Universal Verification</h3>
            <p className="text-gray-700 text-sm">No user or device receives automatic trust, regardless of their network location</p>
          </div>
        </div>
        <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm flex items-start">
          <LockKeyhole className="text-itmgmt-medium-blue mr-3 mt-1 flex-shrink-0" size={20} />
          <div>
            <h3 className="font-semibold text-itmgmt-dark-blue mb-1">Strict Access Controls</h3>
            <p className="text-gray-700 text-sm">Every access request undergoes complete authentication, authorization, and encryption</p>
          </div>
        </div>
        <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm flex items-start">
          <Users className="text-itmgmt-medium-blue mr-3 mt-1 flex-shrink-0" size={20} />
          <div>
            <h3 className="font-semibold text-itmgmt-dark-blue mb-1">Least Privilege Access</h3>
            <p className="text-gray-700 text-sm">Users receive only the minimum access permissions necessary to perform their job functions</p>
          </div>
        </div>
        <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm flex items-start">
          <Server className="text-itmgmt-medium-blue mr-3 mt-1 flex-shrink-0" size={20} />
          <div>
            <h3 className="font-semibold text-itmgmt-dark-blue mb-1">Continuous Monitoring</h3>
            <p className="text-gray-700 text-sm">Systems persistently validate that all connections and user activities remain legitimate</p>
          </div>
        </div>
      </div>
      
      <p className="mb-6 text-gray-700 leading-relaxed">
        Think of conventional security as a castle surrounded by a moat – once someone crosses the drawbridge, they gain relatively 
        free movement within. By contrast, zero-trust resembles a modern high-security facility where each doorway requires badge 
        verification, biometric confirmation, and constant surveillance of all activities.
      </p>
    </>
  );
};

export default SecurityPrinciples;
